export const centerOfTexas = { lat: 31.3915, lng: -99.1707 }
export const mapCenter = { lat: 29.9915, lng: -99.1707 }

// On homepage, the date just goes away (Dont show it on the homepage)
export const GlobalDeadlineDate = new Date(2024, 4, 15, 19, 0, 0)

export const cancelList = [
	'Sold the property',
	"Don't want a subscription",
	'Unhappy with results',
	'Prefer to DIY protest',
	'Trying another agent',
]

export default {
	centerOfTexas,
	mapCenter,
	GlobalDeadlineDate,
}
